import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { useFormspree } from "@/lib/formspree";

export const WaitlistForm = ({ id = "waitlist", dark = false, source = "website" }) => {
  const { status, error, submit, turnstileRef } = useFormspree("waitlist");
  const [email, setEmail] = useState("");
  const [church, setChurch] = useState("");
  const [hosting, setHosting] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    submit({ email, church_name: church, hosting_preference: hosting, source, _subject: `Grace Treasury waitlist sign-up [${hosting || "Hosting: not specified"}]` });
  };

  if (status === "success") {
    return (
      <div className={`flex items-start gap-3 border-l-2 border-gold py-2 pl-4 ${dark ? "text-white" : "text-navy"}`} data-testid={`${id}-success`}>
        <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
        <p className="text-sm leading-relaxed">You're on the list. We'll write to {email} when launch pricing is ready.</p>
      </div>
    );
  }

  const field = dark ? "field field-dark" : "field";
  return (
    <form onSubmit={onSubmit} className="w-full" data-testid={`${id}-form`}>
      <div className="grid gap-3 sm:grid-cols-[1.3fr_1fr_auto]">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" aria-label="Email address" className={field} data-testid={`${id}-email-input`} />
        <input type="text" value={church} onChange={(e) => setChurch(e.target.value)} placeholder="Church name (optional)" aria-label="Church name" className={field} data-testid={`${id}-church-input`} />
        <button type="submit" disabled={status === "sending"} className={dark ? "btn-gold" : "btn-outline"} data-testid={`${id}-submit-button`}>
          {status === "sending" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Join the waitlist"}
        </button>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-2" role="radiogroup" aria-label="Hosting preference" data-testid={`${id}-hosting`}>
        <span className={`mr-1 w-full text-xs sm:w-auto ${dark ? "text-slate-300" : "text-slate-600"}`}>Hosting preference (optional):</span>
        {["Hosted", "Self-hosted"].map((h) => {
          const on = hosting === h;
          const tone = dark
            ? on ? "border-[#c5a059] bg-[#c5a059] text-navy" : "border-white/25 text-slate-200 hover:border-[#c5a059]"
            : on ? "border-navy bg-navy text-white" : "border-slate-300 text-slate-700 hover:border-navy";
          return (
            <button key={h} type="button" role="radio" aria-checked={on} onClick={() => setHosting(on ? "" : h)} className={`h-8 rounded-full border px-4 text-xs font-medium transition-colors duration-200 ${tone}`} data-testid={`${id}-hosting-${h.toLowerCase()}`}>
              {h}
            </button>
          );
        })}
      </div>
      <div ref={turnstileRef} className="mt-3 empty:hidden" data-testid={`${id}-turnstile`} />
      {error && (
        <p role="alert" className={`mt-3 text-sm ${dark ? "text-amber-200" : "text-red-700"}`} data-testid={`${id}-error`}>
          {error}
        </p>
      )}
    </form>
  );
};
